var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPoiName({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13 8 3 8h-2l-.375-1h-3.25L10 16H8l3-8h2Zm-1 2.667L12.875 13h-1.75L12 10.667Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm2 0h16v16H4V4Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPoiName);
export default __webpack_public_path__ + "static/media/ic_action_poi_name.5c97c7aef5b7ddc31549dc228a3f1503.svg";
export { ForwardRef as ReactComponent };